import { createAction, props } from "@ngrx/store";
import { PrintActionTypes } from "src/app/constants/StoreConstants";

export const SetPrintScreenerState = createAction(
  PrintActionTypes.SetPrintScreenerState,
  props<{hasLoadedScreener: boolean}>()
);

export const SetPrintInitialAssessmentState = createAction(
  PrintActionTypes.SetPrintInitialAssessmentState,
  props<{hasLoadedInitialAssessment: boolean}>()
);

export const SetPrintSelfAssessmentState = createAction(
  PrintActionTypes.SetPrintSelfAssessmentState,
  props<{hasLoadedSelfAssessment: boolean}>()
);

export const SetPrintQandAState = createAction(
  PrintActionTypes.SetPrintQandAState,
  props<{hasLoadedQandA: boolean}>()
);

export const SetPrintLearnerRecordTabState = createAction(
  PrintActionTypes.SetPrintLearnerRecordTabState,
  props<{hasLoadedLearnerRecordTab: boolean}>()
);

export const SetPrintSkillsCheckState = createAction(
  PrintActionTypes.SetPrintSkillsCheckState,
  props<{hasLoadedSkillsCheck: boolean}>()
);

export const SetPrintSkillsCheckQandAState = createAction(
  PrintActionTypes.SetPrintSkillsCheckQandAState,
  props<{hasLoadedSkillsCheckQandA: boolean}>()
);

export const SetPrintWrittenAssignState = createAction(
  PrintActionTypes.SetPrintWrittenAssignState,
  props<{hasLoadedWrittenAssignment: boolean}>()
);

export const SetPrintLoaderState = createAction(
  PrintActionTypes.SetPrintLoaderState,
  props<{loader: boolean}>()
);

export const ClearPrintState = createAction(
  PrintActionTypes.ClearPrintLoaderState
);